import { useEffect } from 'react';
import { useUnreadQuestionsCount } from '../useUnreadQuestionsCount';

export function useMarkQuestionsAsRead(eventId) {
    const unreadQuestions = useUnreadQuestionsCount(eventId);

    useEffect(() => {
        if (unreadQuestions > 0) {
            app.api.questions.markAsRead(eventId);
        }
    }, [unreadQuestions]);
}
